export function fromEntries<K, V>(xs: [string, V][]): { [k: string]: V } {
  const o: { [k: string]: V } = {};
  xs.forEach(([k, v]) => {
    o[k] = v;
  });
  return o;
}
